module.exports = __webpack_public_path__ + "static/media/bulk_question_create.46c8cae6.csv";